import { Box, Icon, Typography } from "@mui/material";

 export const RecommendedBadge = () => {
    return (
      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          alignContent: 'center',
          backgroundColor: '#1A55F9',
          padding: '2px 6px',
          borderRadius: '5px',
          borderBottomLeftRadius: 0,
          color: 'white',
        }}
      >
        <Icon
          component="img"
          src="/images/lightning.svg"
          alt="Recommended"
          sx={{ width: '7px', height: '12px' }}
        />

        <Typography
          sx={{
            fontSize: '12px',
            marginLeft: '6px',
            fontWeight: 500,
          }}
        >
          Recommended
        </Typography>
      </Box>
    );
  };
